(function () {
  'use strict';

  var TARGET_HANDLE = 'white-french-linen-bedding-and-bed-sheets';
  var MODAL_ID = 'bed-set-upgrade-modal';
  var STYLE_ID = 'bed-set-upgrade-styles';
  var handlingClick = false;

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function isEligiblePage() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path === '/products/' + TARGET_HANDLE) return true;

    var linkedProducts =
      window.linkedProductData &&
      Array.isArray(window.linkedProductData.linkedProducts)
        ? window.linkedProductData.linkedProducts
        : [];

    return linkedProducts.some(function (product) {
      return product && product.handle === TARGET_HANDLE;
    });
  }

  function getComponent(button) {
    var root = button.closest('[x-data]');
    if (!root) return null;

    if (window.Alpine && typeof window.Alpine.$data === 'function') {
      try {
        var alpineData = window.Alpine.$data(root);
        if (
          alpineData &&
          Array.isArray(alpineData.selectedItems) &&
          Array.isArray(alpineData.setProducts) &&
          typeof alpineData.addToCart === 'function'
        ) {
          return alpineData;
        }
      } catch (error) {
        console.warn('[Bed set upgrade] Alpine.$data lookup failed', error);
      }
    }

    var stack = root._x_dataStack;
    if (Array.isArray(stack)) {
      for (var i = 0; i < stack.length; i += 1) {
        if (
          stack[i] &&
          Array.isArray(stack[i].selectedItems) &&
          Array.isArray(stack[i].setProducts) &&
          typeof stack[i].addToCart === 'function'
        ) {
          return stack[i];
        }
      }
    }

    return null;
  }

  function getActiveColour(component) {
    var linkedProducts = Array.isArray(component.linkedProducts)
      ? component.linkedProducts
      : [];
    var currentHandle = component.currentHandle ||
      window.location.pathname.split('/products/')[1] || '';
    var currentProduct = linkedProducts.find(function (product) {
      return product && product.handle === currentHandle;
    });
    var label = currentProduct && currentProduct.dynamic_value
      ? String(currentProduct.dynamic_value)
      : '';

    return {
      label: label,
      key: normalise(label)
    };
  }

  function getProductText(product) {
    if (!product) return '';

    return normalise([
      product.type,
      product.title,
      product.handle,
      Array.isArray(product.bundle_items)
        ? product.bundle_items.join(' ')
        : ''
    ].join(' '));
  }

  function isBedSetProduct(product) {
    var text = getProductText(product);
    if (!text) return false;

    return (
      /\bbed sets?\b/.test(text) ||
      /\bbedding sets?\b/.test(text) ||
      (
        /\bduvet cover\b/.test(text) &&
        /\bfitted sheet\b/.test(text) &&
        /\bpillowcases?\b/.test(text)
      )
    );
  }

  function isPillowcaseProduct(product) {
    if (!product || isBedSetProduct(product)) return false;
    return /\bpillowcases?\b/.test(getProductText(product));
  }

  function productMatchesColour(product, colourKey) {
    if (!product || !colourKey) return false;

    var productWords = normalise([
      product.title,
      product.handle
    ].join(' ')).split(' ');
    var colourWords = colourKey.split(' ').filter(Boolean);

    return colourWords.length > 0 && colourWords.every(function (word) {
      return productWords.indexOf(word) !== -1;
    });
  }

  function isPurchasable(variant) {
    if (!variant) return false;
    if (variant.available === true) return true;
    return normalise(variant.inventory_policy) === 'continue';
  }

  function findProductForVariant(component, variantId) {
    var products = Array.isArray(component.setProducts)
      ? component.setProducts
      : [];
    var targetId = String(variantId);

    for (var i = 0; i < products.length; i += 1) {
      var variants = Array.isArray(products[i].variants)
        ? products[i].variants
        : [];

      for (var j = 0; j < variants.length; j += 1) {
        if (String(variants[j].id) === targetId) {
          return {
            product: products[i],
            variant: variants[j]
          };
        }
      }
    }

    return null;
  }

  function getSelectedItemsForColour(component, colourKey, includeBedSets) {
    return component.selectedItems.filter(function (item) {
      var match = findProductForVariant(component, item.id);
      if (!match || !productMatchesColour(match.product, colourKey)) {
        return false;
      }

      return includeBedSets || !isBedSetProduct(match.product);
    });
  }

  function selectionContainsMatchingBedSet(component, colourKey) {
    return component.selectedItems.some(function (item) {
      var match = findProductForVariant(component, item.id);
      return Boolean(
        match &&
        isBedSetProduct(match.product) &&
        productMatchesColour(match.product, colourKey)
      );
    });
  }

  function getReplaceablePillowcaseItems(component, colourKey) {
    return component.selectedItems.filter(function (item) {
      var match = findProductForVariant(component, item.id);
      return Boolean(
        match &&
        isPillowcaseProduct(match.product) &&
        productMatchesColour(match.product, colourKey)
      );
    });
  }

  function removeSelectedItems(component, items) {
    if (!items.length) return;

    var idsToRemove = {};
    items.forEach(function (item) {
      idsToRemove[String(item.id)] = true;
    });

    component.selectedItems = component.selectedItems.filter(function (item) {
      return !idsToRemove[String(item.id)];
    });

    if (typeof component.saveItems === 'function') {
      component.saveItems.call(component);
    }
  }

  function detectSize(value) {
    var text = normalise(value);
    var sizes = [
      'super emperor',
      'emperor',
      'super king',
      'king',
      'double',
      'single'
    ];

    for (var i = 0; i < sizes.length; i += 1) {
      if (text.indexOf(sizes[i]) !== -1) return sizes[i];
    }

    return '';
  }

  function preferredSize(component, colourKey) {
    var counts = {};
    var selectedItems = getSelectedItemsForColour(component, colourKey, false);

    selectedItems.forEach(function (item) {
      var match = findProductForVariant(component, item.id);
      var source = [
        item.variant,
        item.title,
        match && match.variant ? match.variant.title : ''
      ].join(' ');
      var size = detectSize(source);

      if (size) {
        counts[size] = (counts[size] || 0) + Number(item.quantity || 1);
      }
    });

    return Object.keys(counts).sort(function (a, b) {
      return counts[b] - counts[a];
    })[0] || '';
  }

  function getBedSetOptions(component, colourKey) {
    var options = [];
    var products = Array.isArray(component.setProducts)
      ? component.setProducts
      : [];
    var preferred = preferredSize(component, colourKey);

    products.forEach(function (product) {
      if (!isBedSetProduct(product)) return;
      if (!productMatchesColour(product, colourKey)) return;

      (product.variants || []).forEach(function (variant) {
        if (!isPurchasable(variant)) return;

        var size = detectSize(variant.title);
        var score = 0;

        if (preferred && size === preferred) score += 100;
        if (variant.available === true) score += 10;

        options.push({
          product: product,
          variant: variant,
          score: score
        });
      });
    });

    options.sort(function (a, b) {
      return (
        b.score - a.score ||
        Number(a.variant.price || 0) - Number(b.variant.price || 0)
      );
    });

    return options;
  }

  function formatMoney(pence) {
    var amount = Number(pence || 0) / 100;

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(amount);
    } catch (error) {
      return '£' + amount.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.bed-set-upgrade{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:20px}',
      '.bed-set-upgrade__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.48)}',
      '.bed-set-upgrade__panel{position:relative;width:min(560px,100%);max-height:calc(100vh - 40px);overflow:auto;background:#fff;padding:28px;box-shadow:0 18px 60px rgba(0,0,0,.25)}',
      '.bed-set-upgrade__close{position:absolute;top:12px;right:12px;width:36px;height:36px;border:0;background:transparent;font-size:28px;line-height:1;cursor:pointer}',
      '.bed-set-upgrade__eyebrow{margin:0 40px 8px 0;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}',
      '.bed-set-upgrade__title{margin:0 40px 12px 0;font-size:24px;line-height:1.2}',
      '.bed-set-upgrade__copy{margin:0 0 18px;line-height:1.55}',
      '.bed-set-upgrade__label{display:block;margin-bottom:8px;font-weight:700}',
      '.bed-set-upgrade__select{width:100%;min-height:48px;padding:10px 40px 10px 12px;margin:0 0 14px;border:1px solid #9a9a9a;background:#fff}',
      '.bed-set-upgrade__details{padding:14px;margin:0 0 14px;border:1px solid #d8d8d8;background:#fafafa}',
      '.bed-set-upgrade__details-title{display:block;margin-bottom:4px;font-weight:700}',
      '.bed-set-upgrade__details-meta{display:block;font-size:14px}',
      '.bed-set-upgrade__warning{margin:0 0 20px;font-size:13px;line-height:1.45;color:#555}',
      '.bed-set-upgrade__actions{display:grid;gap:10px}',
      '.bed-set-upgrade__button{min-height:48px;padding:12px 18px;border:1px solid #172b3a;font-weight:700;cursor:pointer}',
      '.bed-set-upgrade__button--primary{background:#172b3a;color:#fff}',
      '.bed-set-upgrade__button--secondary{background:#fff;color:#172b3a}',
      '@media (max-width:600px){.bed-set-upgrade{align-items:flex-end;padding:0}.bed-set-upgrade__panel{width:100%;max-height:88vh;padding:24px 20px}.bed-set-upgrade__title{font-size:21px}}'
    ].join('');

    document.head.appendChild(style);
  }

  function closeExistingModal() {
    var existing = document.getElementById(MODAL_ID);
    if (existing) existing.remove();
  }

  function showModal(options, colourLabel, replacePillowcaseCount) {
    return new Promise(function (resolve) {
      closeExistingModal();
      addStyles();

      var modal = document.createElement('div');
      modal.id = MODAL_ID;
      modal.className = 'bed-set-upgrade';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'bed-set-upgrade-title');

      var optionHtml = options.map(function (entry, index) {
        var label = [
          entry.product.title,
          entry.variant.title && entry.variant.title !== 'Default Title'
            ? entry.variant.title
            : '',
          formatMoney(entry.variant.price)
        ].filter(Boolean).join(' — ');

        return '<option value="' + index + '">' +
          escapeHtml(label) +
          '</option>';
      }).join('');

      var safeColour = escapeHtml(colourLabel || 'matching');
      var replacingPillowcases = replacePillowcaseCount > 0;
      var copy = replacingPillowcases
        ? 'Choose a bed set in the same colour. Your selected pillowcase' +
          (replacePillowcaseCount === 1 ? '' : 's') +
          ' will be replaced by the bed set and will not be added separately.'
        : 'You have selected individual products. Choose a bed set in the same colour to add to the same basket.';
      var warning = replacingPillowcases
        ? 'All other selected products remain in the basket. Set contents, fitted-sheet depth and pillowcase style can differ, so review the selected set before continuing.'
        : 'The bed set is added alongside your individual products. Set contents, fitted-sheet depth and pillowcase style can differ, so review the selected set before continuing.';
      var primaryLabel = replacingPillowcases
        ? 'Replace pillowcase' + (replacePillowcaseCount === 1 ? '' : 's') + ' with bed set'
        : 'Add bed set and continue';

      modal.innerHTML =
        '<div class="bed-set-upgrade__backdrop" data-bed-set-continue></div>' +
        '<div class="bed-set-upgrade__panel">' +
          '<button type="button" class="bed-set-upgrade__close" data-bed-set-continue aria-label="Close">&times;</button>' +
          '<p class="bed-set-upgrade__eyebrow">Complete the range</p>' +
          '<h2 class="bed-set-upgrade__title" id="bed-set-upgrade-title">Add a matching ' + safeColour + ' bed set?</h2>' +
          '<p class="bed-set-upgrade__copy">' + escapeHtml(copy) + '</p>' +
          '<label class="bed-set-upgrade__label" for="bed-set-upgrade-select">Bed set</label>' +
          '<select class="bed-set-upgrade__select" id="bed-set-upgrade-select">' +
            optionHtml +
          '</select>' +
          '<div class="bed-set-upgrade__details" aria-live="polite">' +
            '<span class="bed-set-upgrade__details-title"></span>' +
            '<span class="bed-set-upgrade__details-meta"></span>' +
          '</div>' +
          '<p class="bed-set-upgrade__warning">' + escapeHtml(warning) + '</p>' +
          '<div class="bed-set-upgrade__actions">' +
            '<button type="button" class="bed-set-upgrade__button bed-set-upgrade__button--primary" data-bed-set-add>' + escapeHtml(primaryLabel) + '</button>' +
            '<button type="button" class="bed-set-upgrade__button bed-set-upgrade__button--secondary" data-bed-set-continue>Continue without bed set</button>' +
          '</div>' +
        '</div>';

      var select = modal.querySelector('#bed-set-upgrade-select');
      var detailsTitle = modal.querySelector('.bed-set-upgrade__details-title');
      var detailsMeta = modal.querySelector('.bed-set-upgrade__details-meta');
      var completed = false;

      function selectedEntry() {
        return options[Number(select.value) || 0];
      }

      function updateDetails() {
        var entry = selectedEntry();
        if (!entry) return;

        detailsTitle.textContent = entry.product.title;
        detailsMeta.textContent = [
          entry.variant.title && entry.variant.title !== 'Default Title'
            ? entry.variant.title
            : '',
          formatMoney(entry.variant.price)
        ].filter(Boolean).join(' · ');
      }

      function finish(value) {
        if (completed) return;
        completed = true;
        document.removeEventListener('keydown', onKeydown);
        modal.remove();
        resolve(value);
      }

      function onKeydown(event) {
        if (event.key === 'Escape') finish(null);
      }

      select.addEventListener('change', updateDetails);
      modal.querySelector('[data-bed-set-add]').addEventListener('click', function () {
        finish(selectedEntry());
      });
      modal.querySelectorAll('[data-bed-set-continue]').forEach(function (element) {
        element.addEventListener('click', function () {
          finish(null);
        });
      });
      document.addEventListener('keydown', onKeydown);
      document.body.appendChild(modal);
      updateDetails();
      modal.querySelector('[data-bed-set-add]').focus();
    });
  }

  document.addEventListener('click', function (event) {
    var button =
      event.target && event.target.closest
        ? event.target.closest('[data-set-add]')
        : null;

    if (!button || handlingClick || !isEligiblePage()) return;

    var component = getComponent(button);

    if (
      !component ||
      !Array.isArray(component.selectedItems) ||
      component.selectedItems.length === 0
    ) {
      return;
    }

    var activeColour = getActiveColour(component);
    if (!activeColour.key) return;

    var activeColourItems = getSelectedItemsForColour(
      component,
      activeColour.key,
      false
    );

    // Switching colour alone should not trigger an offer. At least one
    // individual product from the active colour must be selected.
    if (activeColourItems.length === 0) return;

    // A bed set in another colour must not suppress this offer. Only avoid
    // recommending a duplicate bed set for the currently active colour.
    if (selectionContainsMatchingBedSet(component, activeColour.key)) return;

    var options = getBedSetOptions(component, activeColour.key);

    // No same-colour bed set is currently purchasable: continue normally.
    if (options.length === 0) return;

    var replaceablePillowcases = getReplaceablePillowcaseItems(
      component,
      activeColour.key
    );

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    handlingClick = true;

    showModal(
      options,
      activeColour.label,
      replaceablePillowcases.length
    )
      .then(function (selectedBedSet) {
        if (selectedBedSet) {
          // The bed set replaces the individual products selected for the
          // active colour, so they must not also be submitted to the cart.
          removeSelectedItems(component, activeColourItems);

          component.changeQuantity.call(
            component,
            String(selectedBedSet.variant.id),
            1,
            selectedBedSet.product.title,
            selectedBedSet.variant.title
          );
        }

        return component.addToCart.call(component);
      })
      .catch(function (error) {
        console.error('[Bed set upgrade] Failed', error);
        return component.addToCart.call(component);
      })
      .then(function () {
        handlingClick = false;
      }, function () {
        handlingClick = false;
      });
  }, true);
})();
